import { apiClient } from "@/lib/api/client";

export type TenantMembershipDto = {
  id: string;
  name: string;
  domain: string | null;
  owner_id?: string | null;
  company_name?: string | null;
  logo_url?: string | null;
  is_active: boolean;
  created_at?: string | null;
};

export async function listTenants(): Promise<TenantMembershipDto[]> {
  const { data } = await apiClient.get<TenantMembershipDto[]>("/tenants");
  return data;
}

export type TenantCreateBody = {
  name: string;
  company_name?: string | null;
  domain?: string | null;
  owner_id: string;
  is_active?: boolean;
};

export type TenantUpdateBody = Partial<Omit<TenantCreateBody, "owner_id">> & {
  is_active?: boolean;
};

export async function createTenant(body: TenantCreateBody): Promise<TenantMembershipDto> {
  const { data } = await apiClient.post<TenantMembershipDto>("/tenants", body);
  return data;
}

export async function updateTenant(tenantId: string, body: TenantUpdateBody): Promise<TenantMembershipDto> {
  const { data } = await apiClient.put<TenantMembershipDto>(`/tenants/${tenantId}`, body);
  return data;
}

export async function updateTenantOwner(tenantId: string, ownerId: string): Promise<TenantMembershipDto> {
  const { data } = await apiClient.patch<TenantMembershipDto>(`/tenants/${tenantId}/owner`, {
    owner_id: ownerId,
  });
  return data;
}

export async function uploadTenantLogo(tenantId: string, file: File): Promise<TenantMembershipDto> {
  const form = new FormData();
  form.append("file", file);
  const { data } = await apiClient.post<TenantMembershipDto>(`/tenants/${tenantId}/logo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function deleteTenantLogo(tenantId: string): Promise<TenantMembershipDto> {
  const { data } = await apiClient.delete<TenantMembershipDto>(`/tenants/${tenantId}/logo`);
  return data;
}

export async function deleteTenant(tenantId: string): Promise<void> {
  await apiClient.delete(`/tenants/${tenantId}`);
}
